import { useState, useEffect, useCallback } from 'react';
import { getMyAssignments } from '@/api/TournamentManagement/refereeApi';
import type { MyAssignmentsView } from '@/models/tournament';

export interface UseMyAssignmentsParams {
  page?: number;
  pageSize?: number;
}

export function useMyAssignments(params?: UseMyAssignmentsParams) {
  const [data, setData] = useState<MyAssignmentsView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getMyAssignments(params);
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, [params?.page, params?.pageSize]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
